import { RiUserLine } from "@itandi/itandi-bb-ui";
import { Input } from "@itandi/itandi-bb-ui/Input";
import { InputDatev2 } from "@itandi/itandi-bb-ui/InputDatev2";
import { PresentationChip } from "@itandi/itandi-bb-ui/PresentationChip";
import type React from "react";
import { useFormContext } from "react-hook-form";
import type { DealUpdateParam } from "~/models/DealForm";
import { isTenantRequired } from "~/models/DealForm";
import { formatDate, toDate } from "~/utils/DateUtil";
import Styles from "./Block.module.scss";

export const TenantBlock: React.FC = () => {
	const { register, watch, formState, setValue } =
		useFormContext<DealUpdateParam>();
	const dealType = watch("dealType");
	const inspectionBy = watch("inspectionBy");
	const witnessType = watch("witnessType");
	const leasingOriginStartDate = watch("leasingOriginStartDate");
	const { errors } = formState;
	const isRequired = isTenantRequired({ dealType, inspectionBy, witnessType });
	return (
		<div>
			<div className={Styles.FormRow}>
				<div className={Styles.FormRowLabel}>
					<span className={Styles.BlockIconWrapper}>
						<RiUserLine className={Styles.BlockIcon} />
					</span>
					契約者情報
				</div>
			</div>
			<div className={Styles.FormRow}>
				<div className={Styles.FormLabelCol}>
					<span className={Styles.FormLabelText}>契約者氏名</span>
					{isRequired ? (
						<PresentationChip variant="red">必須</PresentationChip>
					) : null}
				</div>
				<div className={Styles.FormSettingCol}>
					氏名
					<Input isInvalid={!!errors.tenantName} {...register("tenantName")} />
					<div className={Styles.InvalidFeedback}>
						{errors.tenantName?.message}
					</div>
					カナ
					<Input
						isInvalid={!!errors.tenantNameKana}
						{...register("tenantNameKana")}
					/>
					<div className={Styles.InvalidFeedback}>
						{errors.tenantNameKana?.message}
					</div>
					<p className={Styles.Description}>
						※入居者精算書・請求書の宛名として使用します。
					</p>
				</div>
			</div>
			<div className={Styles.FormRow}>
				<div className={Styles.FormLabelCol}>
					<span className={Styles.FormLabelText}>契約者電話番号</span>
					{isRequired ? (
						<PresentationChip variant="red">必須</PresentationChip>
					) : null}
				</div>
				<div className={Styles.FormSettingCol}>
					<Input isInvalid={!!errors.tenantTel} {...register("tenantTel")} />
					<div className={Styles.InvalidFeedback}>
						{errors.tenantTel?.message}
					</div>
				</div>
			</div>
			<div className={Styles.FormRow}>
				<div className={Styles.FormLabelCol}>
					<span className={Styles.FormLabelText}>契約者メールアドレス</span>
				</div>
				<div className={Styles.FormSettingCol}>
					<Input
						isInvalid={!!errors.tenantEmail}
						{...register("tenantEmail")}
					/>
					<div className={Styles.InvalidFeedback}>
						{errors.tenantEmail?.message}
					</div>
				</div>
			</div>
			<div className={Styles.FormRow}>
				<div className={Styles.FormLabelCol}>
					<span className={Styles.FormLabelText}>原契約開始日</span>
				</div>
				<div className={Styles.FormSettingCol}>
					<div>
						<InputDatev2
							maxWidth="13rem"
							onChange={(date) => {
								setValue("leasingOriginStartDate", formatDate(date));
							}}
							value={toDate(leasingOriginStartDate)}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
